import BaseModel from './BaseModel';

/** Class representing a tag. */
class Ticket extends BaseModel {
    static EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
}

/**
 * Get the fields to get server side when we
 * ask for a listing
 */
Ticket.getListingFields = () => [
    '_id', 'created_at', 'contact.firstname', 'contact.lastname',
    'contact.email', 'status', 'type',
    'activated_pricing.name', 'vdr_auth_serial',
    'vdr_auth_key', 'bookings._id'
];

export default Ticket;
